module.exports = __webpack_public_path__ + "static/media/clickit.d666afd6.svg";